import React from "react";
import { MediaPicker } from "./MediaPicker";

export function Text({ label, value, onChange, help, testid, type = "text" }) {
  return (
    <div>
      <label className="block text-xs uppercase tracking-[0.14em] text-taupe mb-2">{label}</label>
      <input type={type} value={value ?? ""} onChange={(e) => onChange(e.target.value)} data-testid={testid}
        className="w-full bg-ivory border border-espresso/20 rounded-md px-4 py-3 focus:outline-none focus:ring-2 focus:ring-brass" />
      {help && <p className="text-[0.68rem] text-taupe mt-1">{help}</p>}
    </div>
  );
}

export function Area({ label, value, onChange, help, rows = 4, testid }) {
  return (
    <div>
      <label className="block text-xs uppercase tracking-[0.14em] text-taupe mb-2">{label}</label>
      <textarea rows={rows} value={value ?? ""} onChange={(e) => onChange(e.target.value)} data-testid={testid}
        className="w-full bg-ivory border border-espresso/20 rounded-md px-4 py-3 focus:outline-none focus:ring-2 focus:ring-brass font-light leading-relaxed" />
      {help && <p className="text-[0.68rem] text-taupe mt-1">{help}</p>}
    </div>
  );
}

export function Toggle({ label, value, onChange, testid }) {
  return (
    <label className="flex items-center gap-3 cursor-pointer" data-testid={testid}>
      <button type="button" onClick={() => onChange(!value)}
        className={`w-11 h-6 rounded-full transition-colors relative ${value ? "bg-sage" : "bg-espresso/20"}`}>
        <span className={`absolute top-0.5 left-0.5 w-5 h-5 bg-ivory rounded-full transition-transform ${value ? "translate-x-5" : ""}`} />
      </button>
      <span className="text-sm text-espresso">{label}</span>
    </label>
  );
}

export function ListArea({ label, value, onChange, help, testid }) {
  const text = Array.isArray(value) ? value.join("\n") : "";
  return (
    <Area label={label} value={text} onChange={(v) => onChange(v.split("\n").map((l) => l.trim()).filter(Boolean))}
      help={help || "One item per line"} rows={5} testid={testid} />
  );
}

export function Field({ def, value, onChange }) {
  const tid = `field-${def.key}`;
  if (def.type === "textarea") return <Area label={def.label} value={value} onChange={onChange} help={def.help} rows={def.rows || 4} testid={tid} />;
  if (def.type === "image") return <MediaPicker label={def.label} value={value} onChange={onChange} recommended={def.recommended} testid={tid} />;
  if (def.type === "video") return <MediaPicker label={def.label} value={value} onChange={onChange} accept="video/*" kind="video" recommended={def.recommended} testid={tid} />;
  if (def.type === "bool") return <Toggle label={def.label} value={value !== false} onChange={onChange} testid={tid} />;
  if (def.type === "list") return <ListArea label={def.label} value={value} onChange={onChange} help={def.help} testid={tid} />;
  return <Text label={def.label} value={value} onChange={onChange} help={def.help} testid={tid} />;
}
